import Linkedin from "@/assets/images/icons/linkedin-footer.svg?inline";
import Facebook from "@/assets/images/icons/facebook-footer.svg?inline";
import Instagram from "@/assets/images/icons/instagram-footer.svg?inline";

export default {
  name: "appFooter",

  components: {
    Linkedin,
    Facebook,
    Instagram
  },

  computed: {
    currentYear() {
      return this.$moment().format("YYYY");
    }
  }
};
